module.exports = __webpack_public_path__ + "static/media/1200w.b8365a87.jpg";